<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title help-btn">
            {{ params['title'] | translate }}
        </h4>
    </div>
    <div class="modal-body">
        <edit-modal-header-action-component [params]="params"  (openFormModalAction)="openFormModal.emit()"  (deleteAction)="delete.emit()" (hideModalAction)="hideModal.emit()"> </edit-modal-header-action-component>

        <ng-template [ngIf]="!formLoading">
            <form [formGroup]="form" novalidate class="mat-form" #formDirective="ngForm">
                <ng-container *ngIf="component === 'categories' || component === 'sub-categories' || component === 'insurances' || component === 'age-groups' || component === 'life-circumstances'">
                    <ng-container *ngFor="let language of languages; let first = first">
                        <mat-expansion-panel class="mt-2"
                                                [ngClass]="((component !== 'categories' && !form.controls['name_' + language['locale']].valid  && formSubmitted) || (component === 'categories' && (!form.controls['name_' + language['locale']].valid || !form.controls['intro_' + language['locale']].valid)  && formSubmitted)) ? 'invalid': ''"
                                                [expanded] = "first || params['action'] === 'create'"
                                                (opened)="panelOpenState = true"
                                                (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ language['name'] }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
    
                            <div class="container">
                                <div class="row">
                                    <div class="form-group col-xs-5">
                                        <mat-form-field class="ps-content">
                                            <input type="text" matInput [placeholder]="('Name' | translate)"
                                                    [formControlName]="'name_' + language['locale']"/>
                                            <small class="form-text text-danger" [hidden]="form.controls['name_' + language['locale']].valid
                                                                                || (form.controls['name_' + language['locale']].pristine
                                                                                && !formSubmitted)">
                                                {{ 'Require at least 3 characters.' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>

                                    <ng-container *ngIf="component === 'categories'">
                                        <div class="form-group col-xs-5">
                                            <mat-form-field class="ps-content">
                                                <input type="text" matInput [placeholder]="('Intro' | translate)"
                                                        [formControlName]="'intro_' + language['locale']"/>
                                                <small class="form-text text-danger" [hidden]="form.controls['intro_' + language['locale']].valid
                                                                                    || (form.controls['intro_' + language['locale']].pristine
                                                                                    && !formSubmitted)">
                                                    {{ 'Require at least 3 characters.' | translate }}
                                                </small>
                                            </mat-form-field>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </ng-container>
                </ng-container>
                
                <!-- Modal for sub-categories edit -->
                <ng-container *ngIf="component === 'sub-categories'">
                    <div class="row mt-2">
                        <div class="form-group col-xs-6">
                            <mat-form-field class="ps-content">
                                <mat-select [placeholder]="'Category' | translate" formControlName="category_id">
                                    <ng-container *ngFor="let category of categories">
                                        <mat-option [value]="category['id']">
                                            {{ category['name_' + itemLanguage] }}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <small class="form-text text-danger" [hidden]="form.controls.category_id.valid || (form.controls.category_id.pristine && !formSubmitted)">
                                    {{ 'This field is required.' | translate }}
                                </small>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>

                <!-- Modal for company edit -->
                <ng-container *ngIf="component === 'companies' || component === 'logos'">
                    <div class="row mt-6">
                        <div class="form-group col-xs-6">
                            <mat-form-field class="ps-content">
                                <input type="text" matInput [placeholder]="('Name' | translate)"
                                        [formControlName]="'name'"/>
                                <small class="form-text text-danger" [hidden]="form.controls['name'].valid
                                                                    || (form.controls['name'].pristine
                                                                    && !formSubmitted)">
                                    {{ 'Require at least 3 characters.' | translate }}
                                </small>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>

                <!-- Modal for logo edit -->
                <ng-container *ngIf="component === 'logos'">
                    <div class="row mt-6">
                        <div class="form-group col-xs-12">
                            <div class="img-space">
                                <ng-container *ngIf="form.controls['logo_url'].value; else elseTemplate">
                                    <img class="logo-thumbnails" width="100%" height="240" [src]="form.controls['logo_url'].value"/>
                                </ng-container>
                                <ng-template #elseTemplate>
                                    <i class="fal fa-file-pdf logo-icon"></i>
                                </ng-template>
                                <div class="img-space--button" [class.disabled]="params['action'] === 'read'">
                                    <image-upload class="image-upload-extension"
                                                  [headers]="{'Authorization': 'Bearer ' + authService.user['token']}"
                                                  [maxFileSize]="2000000"
                                                  [max]="10"
                                                  [fileTooLargeMessage]="('Image too large!' | translate)"
                                                  [extensions]="['jpg','jpeg','png']"
                                                  [url]="authService.baseUrl + 'service-provider-setting/logos/upload'"
                                                  [buttonCaption]="('Select a picture to upload' | translate)"
                                                  (uploadFinished)="thumbnailUploaded($event)"
                                                  [extensions]="['png']"
                                                  [preview]="false" dropBoxMessage=""
                                                  [disabled]="disabled">
                                    </image-upload>
                                    <small class="">{{ 'Max file size: 2MB. Recommend format: png' |
                                        translate }}
                                    </small>
                                </div>
                            </div>
                            <small class="form-text text-danger" [hidden]="form.controls['logo'].valid
                                                        || (form.controls['logo'].pristine
                                                        && !formSubmitted)">
                                {{ 'Logo is required' | translate }}
                            </small>
                        </div>
                    </div>
                </ng-container>

                <!-- Modal for domain texts edit -->
                <ng-container *ngIf="component === 'domain_texts'">
                    <ng-container *ngFor="let language of languages; let first = first">
                        <mat-expansion-panel class="mt-2"
                                                [class.invalid]="(!form.controls['title_' + language['locale']].valid 
                                                        || !form.controls['intro_' + language['locale']].valid
                                                        || !form.controls['characteristics_text_' + language['locale']].valid
                                                        || !form.controls['commonness_text_' + language['locale']].valid
                                                        || !form.controls['treatment_approach_text_' + language['locale']].valid)
                                                        && formSubmitted"
                                                [expanded] = "first || params['action'] === 'create'"
                                                (opened)="panelOpenState = true"
                                                (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{ language['name'] }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
    
                            <div class="container">
                                <div class="row">
                                    <div class="form-group col-xs-10">
                                        <mat-form-field class="ps-content">
                                            <input type="text" matInput [placeholder]="('Name' | translate)"
                                                    [formControlName]="'title_' + language['locale']"/>
                                            <small class="form-text text-danger" [hidden]="form.controls['title_' + language['locale']].valid
                                                                                || (form.controls['title_' + language['locale']].pristine
                                                                                && !formSubmitted)">
                                                {{ 'Require at least 3 characters.' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-xs-5">
                                        <mat-form-field class="ps-content">
                                            <textarea matInput [formControl]="form.controls['intro_' + language['locale']]"
                                                    placeholder="{{ 'Intro' | translate }}"
                                                    rows="2">
                                            </textarea>
                                            <small class="form-text text-danger" [hidden]="form.controls['intro_' + language['locale']].valid
                                                                                || (form.controls['intro_' + language['locale']].pristine
                                                                                && !formSubmitted)">
                                                {{ 'Require at least 3 characters.' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-group col-xs-5">
                                        <mat-form-field class="ps-content">
                                            <textarea matInput [formControl]="form.controls['characteristics_text_' + language['locale']]"
                                                placeholder="{{ 'Characteristics' | translate }}"
                                                rows="2">
                                            </textarea>
                                            <small class="form-text text-danger" [hidden]="form.controls['characteristics_text_' + language['locale']].valid
                                                                                || (form.controls['characteristics_text_' + language['locale']].pristine
                                                                                && !formSubmitted)">
                                                {{ 'Require at least 3 characters.' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-xs-5">
                                        <mat-form-field class="ps-content">
                                            <textarea matInput [formControl]="form.controls['commonness_text_' + language['locale']]"
                                                placeholder="{{ 'Commonness' | translate }}"
                                                rows="2">
                                            </textarea>
                                            <small class="form-text text-danger" [hidden]="form.controls['commonness_text_' + language['locale']].valid
                                                                                || (form.controls['commonness_text_' + language['locale']].pristine
                                                                                && !formSubmitted)">
                                                {{ 'Require at least 3 characters.' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>

                                    <div class="form-group col-xs-5">
                                        <mat-form-field class="ps-content">
                                            <textarea matInput [formControl]="form.controls['treatment_approach_text_' + language['locale']]"
                                                placeholder="{{ 'Treatment approach' | translate }}"
                                                rows="2">
                                            </textarea>
                                            <small class="form-text text-danger" [hidden]="form.controls['treatment_approach_text_' + language['locale']].valid
                                                                                || (form.controls['treatment_approach_text_' + language['locale']].pristine
                                                                                && !formSubmitted)">
                                                {{ 'Require at least 3 characters.' | translate }}
                                            </small>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </ng-container>
                    <div class="row mt-2">
                        <div class="form-group col-xs-6">
                            <mat-form-field class="ps-content">
                                <mat-select [placeholder]="'Domain' | translate" formControlName="domain_id">
                                    <ng-container *ngFor="let domain of domains">
                                        <mat-option [value]="domain['id']">
                                            {{ domain['name_' + itemLanguage] }}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <small class="form-text text-danger" [hidden]="form.controls.domain_id.valid || (form.controls.domain_id.pristine && !formSubmitted)">
                                    {{ 'This field is required.' | translate }}
                                </small>
                            </mat-form-field>
                        </div>
                        <div class="form-group col-xs-6">
                            <mat-form-field class="ps-content">
                                <mat-select [placeholder]="'Included diagnosis' | translate" formControlName="include_diagnosis_id">
                                    <mat-option value=0>
                                        {{ 'None' | translate }}
                                    </mat-option>
                                    <ng-container *ngFor="let diagnosis of diagnoses">
                                        <mat-option [value]="diagnosis['id']">
                                            {{ diagnosis['code'] }}
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>

                <div class="row mt-2">
                    <div class="col-xs-12 text-xs-right">
                        <button type="button" class="btn btn-secondary" (click)="hideModal.emit()">
                            {{ 'Cancel' | translate }}
                        </button>
                        <button *ngIf="params['action'] !== 'read'" type="button" class="btn btn-primary" (click)="submit.emit()">
                            {{ 'Submit' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </ng-template>
    </div>
</div>